import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { equals, record_type, float64_type, int32_type, option_type, string_type, bool_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { minValue } from "../../fable_modules/fable-library.3.7.20/DateOnly.js";
import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";

export class ClientDetailsDTO extends Record {
    constructor(InvoicePeriodEnd, InvoiceRounding, Name, AccountManager, AccountManagerId, Description, InvoiceeClientNr, InvoiceeInvoiceeNr, Enabled, MinimumInvoiceAmountInclVat, NumberOfMonthsToSaveCdrs, MaxMonthsBackToInvoiceTrafic) {
        super();
        this.InvoicePeriodEnd = InvoicePeriodEnd;
        this.InvoiceRounding = InvoiceRounding;
        this.Name = Name;
        this.AccountManager = AccountManager;
        this.AccountManagerId = AccountManagerId;
        this.Description = Description;
        this.InvoiceeClientNr = InvoiceeClientNr;
        this.InvoiceeInvoiceeNr = InvoiceeInvoiceeNr;
        this.Enabled = Enabled;
        this.MinimumInvoiceAmountInclVat = MinimumInvoiceAmountInclVat;
        this.NumberOfMonthsToSaveCdrs = (NumberOfMonthsToSaveCdrs | 0);
        this.MaxMonthsBackToInvoiceTrafic = (MaxMonthsBackToInvoiceTrafic | 0);
    }
}

export function ClientDetailsDTO$reflection() {
    return record_type("Containers.ClientDetails.Api.ClientDetailsDTO", [], ClientDetailsDTO, () => [["InvoicePeriodEnd", class_type("System.DateOnly")], ["InvoiceRounding", bool_type], ["Name", string_type], ["AccountManager", option_type(string_type)], ["AccountManagerId", option_type(int32_type)], ["Description", option_type(string_type)], ["InvoiceeClientNr", option_type(int32_type)], ["InvoiceeInvoiceeNr", option_type(class_type("System.Int64"))], ["Enabled", bool_type], ["MinimumInvoiceAmountInclVat", float64_type], ["NumberOfMonthsToSaveCdrs", int32_type], ["MaxMonthsBackToInvoiceTrafic", int32_type]]);
}

export function ClientDetailsDTO_get_Default() {
    return new ClientDetailsDTO(minValue(), false, "", void 0, void 0, void 0, void 0, void 0, true, 0, 3, 3);
}

export function loadClientDetails(clientNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/clientDetails/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(ClientDetailsDTO$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(ClientDetailsDTO$reflection(), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(ClientDetailsDTO$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function saveClientDetails(clientNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/clientDetails/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(int32_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(int32_type, arg_1, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(ClientDetailsDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(2), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(int32_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

